import styled from "styled-components";

const ResultImagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default ResultImagesContainer;
